import { createActions, createState, createReducer } from 'reduxsauce-crud'
import R from 'ramda'

const d = { deep: true }

export const DisenrollmentsRedux = createActions(
  {
    updateDataAfterInscription: ['data'],
  },
  {
    prefix: 'DISENROLLMENTS_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = DisenrollmentsRedux
export const InscriptionsTypes = Types
export default Creators

export const INITIAL_STATE = createState({}, {
  get: true,
})

const updateDataAfterInscription = (state, { data }) => {
  const newDisenrollments = R.clone(state.get.results)
  const [student] = newDisenrollments.data.filter(child => child.id === data.id)
  const activeStudentIndex = R.findIndex(R.propEq('id', student.id))(newDisenrollments.data)
  newDisenrollments.data.splice(activeStudentIndex, 1)
  return state.merge({ get: { fetching: false, results: newDisenrollments } }, d)
}


export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.updateDataAfterInscription]: updateDataAfterInscription,
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/DisenrollmentsRedux.js